<script>
  import { user } from '../models/user.js';
</script>

<div class="user-nav">
  {#if $user && $user.username}
    <section class="user-info">
      <svg class="icon user-icon"><use href="/icons.svg#person"></use></svg>
      <span class="user-greeting">My Account</span>
    </section>

    <ul class="user-links">
      <li><a class="nav-link link-plain" href="/account/membership">Membership</a></li>
      {#if $user.subscriptionDetails}
        <li><a class="nav-link link-plain" href="/account/stats">Puzzle Stats</a></li>
      {/if}
      <li><a class="nav-link link-plain" href="/account/orders">Orders</a></li>
      <li><a class="nav-link link-plain" href="/account/favorites">Favorites</a></li>
      <li><a class="nav-link link-plain" href="/account/settings">Settings</a></li>
      <li class="user-links-divider"></li>
      <li>
        <a class="nav-link link-plain logout-link" href="/logout" rel="external">
          Sign Out <svg class="icon"><use href="/icons.svg#logout"></use></svg>
        </a>
      </li>
    </ul>
  {:else}
    <section class="user-info">
      <span class="user-greeting">Hello there!</span>
    </section>

    <ul class="user-links">
      <li class="btn-group-expanded">
        <a class="btn" href="/login?referrer={window.location.pathname}">Sign In</a>
        <a class="btn" href="/register">Register</a>
      </li>
    </ul>
  {/if}
</div>

<style>
  .user-nav {
    display: flex;
    flex-direction: column;
    padding: 0;
    min-width: 180px;
  }

  .user-info {
    display: flex;
    align-items: center;
    gap: 0.4rem;
    padding: var(--spacing-sm) var(--spacing-sm);
    border-bottom: solid 1px var(--col-accent-2);
  }

  .user-icon {
    opacity: 0.6;
  }

  .user-greeting {
    font-weight: 600;
    font-size: 0.9rem;
  }

  .user-links {
    padding: var(--spacing-xs) 0;
    margin: 0;
    list-style: none;
  }

  .user-links-divider {
    height: 1px;
    background: var(--col-gray-90);
    margin: var(--spacing-xs) var(--spacing-sm);
  }

  .nav-link {
    display: block;
    box-sizing: border-box;
    padding: 0 var(--spacing-sm);
    line-height: calc(var(--line-height) * 1.8);
    font-size: 0.9rem;
  }

  .logout-link {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: var(--col-danger);
  }

  .btn-group-expanded {
    display: flex;
    gap: var(--spacing-xs);
    padding: var(--spacing-xs) var(--spacing-sm);
  }

  .btn-group-expanded .btn {
    flex: 1;
    text-align: center;
  }
</style>
